import React from "react";
import { connect } from "react-redux";

import NextGenDimPoc from "./NextGenDimPoc";

const NextGenDimPocContainer = props => {
  return <NextGenDimPoc {...props} />;
};

const mapStateToProps = state => {
  const userInfosState = state.userInfos || {};

  return {
    token: state.auth.token,
    userRoleId: userInfosState.role_id
  };
};

export default connect(mapStateToProps)(NextGenDimPocContainer);



// WEBPACK FOOTER //
// src/pages/NextGenDashboard/NextGenDimPoc.container.js